var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAverage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "evenodd",
    d: "m422.536 60.491l30.17 30.17l-61.36 61.36c22.15 28.79 35.32 64.846 35.32 103.979c0 94.256-76.41 170.666-170.666 170.666c-39.133 0-75.19-13.17-103.979-35.32L90.667 452.7l-30.17-30.17l61.205-61.204C98.92 332.317 85.334 295.746 85.334 256c0-94.257 76.41-170.667 170.666-170.667c39.745 0 76.317 13.586 105.325 36.367zm-61.704 122.044L182.535 360.83C203.33 375.431 228.664 384 256 384c70.693 0 128-57.308 128-128c0-27.337-8.57-52.672-23.168-73.465M256 128c-70.692 0-128 57.307-128 128c0 27.952 8.96 53.811 24.164 74.863l178.699-178.7C309.81 136.96 283.953 128 256 128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverage);
export default __webpack_public_path__ + "static/media/average.31da5b675248062b80d1aeb03583f794.svg";
export { ForwardRef as ReactComponent };